import React, { Component } from "react";
import { Checkbox, Radio, Space, Spin, message, Input } from "antd";
import Bridge from "../../../../utils/Bridge";
import {
  RACE_OPTIONS_ECAS,
  ETHNICITY_OPTIONS_ECAS,
} from "../../../../utils/consts";
const { TextArea } = Input;

export default class GenderInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      gender: "",
      race: "",
      race_other_specification: "",
      ethnicity: "",
      ethnicity_other_specification: "",
      loading: false,
      ethnicity_option_list: [
        "Not of Hispanic, Latino/a or Spanish origin",
        "Mexican, Mexican American, Chicano/a",
        "Puerto Rican",
        "Cuban",
        "Another Hispanic Latino/a or Spanish origin",
        "Other",
        "Decline to answer",
      ],

      biological_sex: "",
      ethnic_category: [],
      race: [],
      date_of_birth: null,
      ethnicity_other_specification: "",
    };
  }
  componentDidMount() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    this.get_demographic_details();
  }
  get_demographic_details = () => {
    let params = "?eals_id=" + localStorage.getItem("ap_eals_id");
    Bridge.demographics.le_study
      .get(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.status == "1") {
          if (response.data.length > 0) {
            for (let item of response.data) {
              if (item.field == "Physical sex at birth") {
                this.setState({ biological_sex: item.value });
              }
              if (item.field == "Ethnicity") {
                this.setState({
                  ethnic_category: item.value ? JSON.parse(item.value) : [],
                });
              }
              if (item.field == "Race") {
                this.setState({
                  race: item.value ? JSON.parse(item.value) : [],
                });
              }
              if (item.field == "Race - Specification") {
                this.setState({
                  race_other_specification: item.value,
                });
              }
            }
          }
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  };
  onChangeRace = (e) => {
    let value = e.target.value;
    let tempArr = this.state.race;
    if (tempArr.includes(value)) {
      let newArray = [];
      for (let item of tempArr) {
        if (item != value) {
          newArray.push(item);
        }
      }
      this.setState({ race: newArray });
    } else {
      tempArr.push(value);
      this.setState({ race: tempArr });
    }
  };
  save = () => {
    if (!this.state.biological_sex) {
      message.warning("Physical sex at birth is required");
      return;
    }
    if (this.state.ethnic_category.length === 0) {
      message.warning("Ethnicity is required");
      return;
    }
    if (this.state.race.length === 0) {
      message.warning("At least one race must be selected");
      return;
    }
    // step 2
    let questions = [
      {
        parent_field: "Physical sex at birth",
        field: "Physical sex at birth",
        value: this.state.biological_sex,
      },
      {
        parent_field: "Ethnicity",
        field: "Ethnicity",
        value:
          this.state.ethnic_category.length > 0
            ? JSON.stringify(this.state.ethnic_category)
            : "",
      },
      {
        parent_field: "Race",
        field: "Race",
        value:
          this.state.race.length > 0 ? JSON.stringify(this.state.race) : "",
      },
      {
        parent_field: "Race - Specification",
        field: "Race - Specification",
        value: this.state.race_other_specification,
      },
    ];
    let params = {
      eals_id: localStorage.getItem("ap_eals_id"),
      data: JSON.stringify(questions),
      step: "2",
      action_type: this.props.is_update == true ? "update" : "insert",
    };
    this.setState({ loading: true });
    Bridge.demographics.le_study
      .save(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.data.status == "1") {
          message.success(response.data.message);
          this.setState(
            {
              loading: false,
            },
            () => {
              if (this.props.is_update == true) {
                setTimeout(() => {
                  window.location.assign("/about-me");
                }, 3000);
              } else {
                this.props.set_active_step(4);
              }
            }
          );
        } else {
          message.error(response.data.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };
  onChangeEthnicity = (e) => {
    let value = e.target.value;
    let tempArr = this.state.ethnic_category;
    if (!tempArr.includes("Of Hispanic, Latino/a or Spanish Origin")) {
      tempArr = tempArr.filter(
        (item) => item != "Mexican, Mexican American, Chicano/a"
      );
      tempArr = tempArr.filter((item) => item != "Puerto Rican");
      tempArr = tempArr.filter((item) => item != "Cuban");
      tempArr = tempArr.filter(
        (item) => item != "Another Hispanic, Latino/a or Spanish origin"
      );
    }
    if (tempArr.includes(value)) {
      let newArray = [];
      for (let item of tempArr) {
        if (item != value) {
          newArray.push(item);
        }
      }
      if (!newArray.includes("Other")) {
        this.setState({ ethnicity_other_specification: "" });
      }
      this.setState({ ethnic_category: newArray });
    } else {
      tempArr.push(value);
      if (!tempArr.includes("Other")) {
        this.setState({ ethnicity_other_specification: "" });
      }
      this.setState({ ethnic_category: tempArr });
    }
  };
  onChangeRace = (e) => {
    let value = e.target.value;
    let tempArr = this.state.race;
    if (!tempArr.includes("Asian")) {
      tempArr = tempArr.filter((item) => item != "Asian Indian");
      tempArr = tempArr.filter((item) => item != "Chinese");
      tempArr = tempArr.filter((item) => item != "Filipino");
      tempArr = tempArr.filter((item) => item != "Japanese");
      tempArr = tempArr.filter((item) => item != "Korean");
      tempArr = tempArr.filter((item) => item != "Vietnamese");
      tempArr = tempArr.filter((item) => item != "Other Asian");
    }
    if (tempArr.includes(value)) {
      let newArray = [];
      for (let item of tempArr) {
        if (item != value) {
          newArray.push(item);
        }
      }
      if (!newArray.includes("Other")) {
        this.setState({ race_other_specification: "" });
      }
      this.setState({ race: newArray });
    } else {
      tempArr.push(value);
      if (!tempArr.includes("Other")) {
        this.setState({ race_other_specification: "" });
      }
      this.setState({ race: tempArr });
    }
  };
  render() {
    return (
      <div>
        <div className="header">
          <h3>GENDER, RACE AND ETHNICITY </h3>
          <div className="white-block"></div>
        </div>
        <Spin spinning={this.state.loading}>
          <div className="form-fields">
            <div className="form-group">
              <label className="input-heading">
                Physical sex at birth
                <span className="text-danger">*</span>
              </label>
              <br />
              <Radio.Group
                onChange={(e) =>
                  this.setState({
                    biological_sex: e.target.value,
                  })
                }
                value={this.state.biological_sex}
                direction="vertical"
              >
                <Space direction="horizontal">
                  <Radio value={"Male"}>Male</Radio>
                  <Radio value={"Female"}>Female</Radio>
                </Space>
              </Radio.Group>
            </div>
            <div className="form-group">
              <label className="input-heading">
                Ethnicity
                <span className="text-danger">*</span>
              </label>
              <br />
              <ul>
                <li className="pb-1">
                  <Checkbox
                    value={"Not of Hispanic, Latino/a or Spanish origin"}
                    onChange={this.onChangeEthnicity}
                    checked={
                      this.state.ethnic_category.includes(
                        "Not of Hispanic, Latino/a or Spanish origin"
                      )
                        ? true
                        : false
                    }
                  >
                    Not of Hispanic, Latino/a or Spanish origin
                  </Checkbox>
                </li>
                <li className="pb-1">
                  <Checkbox
                    value={"Of Hispanic, Latino/a or Spanish Origin"}
                    onChange={this.onChangeEthnicity}
                    checked={
                      this.state.ethnic_category.includes(
                        "Of Hispanic, Latino/a or Spanish Origin"
                      )
                        ? true
                        : false
                    }
                  >
                    Of Hispanic, Latino/a or Spanish Origin
                  </Checkbox>
                </li>
                {this.state.ethnicity.includes(
                  "Of Hispanic, Latino/a or Spanish Origin"
                ) && (
                  <div style={{ paddingLeft: 45 }}>
                    <li className="pb-1">
                      <Checkbox
                        value={"Mexican, Mexican American, Chicano/a"}
                        onChange={this.onChangeEthnicity}
                        checked={
                          this.state.ethnic_category.includes(
                            "Mexican, Mexican American, Chicano/a"
                          )
                            ? true
                            : false
                        }
                      >
                        Mexican, Mexican American, Chicano/a
                      </Checkbox>
                    </li>
                    <li className="pb-1">
                      <Checkbox
                        value={"Puerto Rican"}
                        onChange={this.onChangeEthnicity}
                        checked={
                          this.state.ethnic_category.includes("Puerto Rican")
                            ? true
                            : false
                        }
                      >
                        Puerto Rican
                      </Checkbox>
                    </li>
                    <li className="pb-1">
                      <Checkbox
                        checked={
                          this.state.ethnic_category.includes("Cuban")
                            ? true
                            : false
                        }
                        value={"Cuban"}
                        onChange={this.onChangeEthnicity}
                      >
                        Cuban
                      </Checkbox>
                    </li>
                    <li className="pb-1">
                      <Checkbox
                        checked={
                          this.state.ethniethnic_categorycity.includes(
                            "Another Hispanic, Latino/a or Spanish origin"
                          )
                            ? true
                            : false
                        }
                        value={"Another Hispanic, Latino/a or Spanish origin"}
                        onChange={this.onChangeEthnicity}
                      >
                        Another Hispanic, Latino/a or Spanish origin
                      </Checkbox>
                    </li>
                  </div>
                )}
                <li className="pb-1">
                  <Checkbox
                    checked={
                      this.state.ethnic_category.includes(
                        "Prefer not to answer"
                      )
                        ? true
                        : false
                    }
                    value={"Prefer not to answer"}
                    onChange={this.onChangeEthnicity}
                  >
                    Prefer not to answer
                  </Checkbox>
                </li>
              </ul>
            </div>
            <div className="form-group">
              <label className="input-heading">
                Race &nbsp;
                <i style={{ fontWeight: "400" }}>
                  (select all that apply)
                </i>{" "}
                <span className="text-danger">*</span>
              </label>
              <ul>
                <li className="pb-1">
                  <Checkbox
                    value={"American Indian or Alaska Native"}
                    onChange={this.onChangeRace}
                    checked={
                      this.state.race.includes(
                        "American Indian or Alaska Native"
                      )
                        ? true
                        : false
                    }
                  >
                    American Indian or Alaska Native
                  </Checkbox>
                </li>
                <li className="pb-1">
                  <Checkbox
                    value={"Asian"}
                    checked={this.state.race.includes("Asian") ? true : false}
                    onChange={this.onChangeRace}
                  >
                    Asian
                  </Checkbox>
                </li>
                {this.state.race.includes("Asian") && (
                  <div style={{ paddingLeft: 45 }}>
                    <li className="pb-1">
                      <Checkbox
                        checked={
                          this.state.race.includes("Asian Indian")
                            ? true
                            : false
                        }
                        value={"Asian Indian"}
                        onChange={this.onChangeRace}
                      >
                        Asian Indian
                      </Checkbox>
                    </li>
                    <li className="pb-1">
                      <Checkbox
                        checked={
                          this.state.race.includes("Chinese") ? true : false
                        }
                        value={"Chinese"}
                        onChange={this.onChangeRace}
                      >
                        Chinese
                      </Checkbox>
                    </li>
                    <li className="pb-1">
                      <Checkbox
                        checked={
                          this.state.race.includes("Filipino") ? true : false
                        }
                        value={"Filipino"}
                        onChange={this.onChangeRace}
                      >
                        Filipino
                      </Checkbox>
                    </li>
                    <li className="pb-1">
                      <Checkbox
                        checked={
                          this.state.race.includes("Japanese") ? true : false
                        }
                        value={"Japanese"}
                        onChange={this.onChangeRace}
                      >
                        Japanese
                      </Checkbox>
                    </li>
                    <li className="pb-1">
                      <Checkbox
                        checked={
                          this.state.race.includes("Korean") ? true : false
                        }
                        value={"Korean"}
                        onChange={this.onChangeRace}
                      >
                        Korean
                      </Checkbox>
                    </li>
                    <li className="pb-1">
                      <Checkbox
                        checked={
                          this.state.race.includes("Vietnamese") ? true : false
                        }
                        value={"Vietnamese"}
                        onChange={this.onChangeRace}
                      >
                        Vietnamese
                      </Checkbox>
                    </li>
                    <li className="pb-1">
                      <Checkbox
                        checked={
                          this.state.race.includes("Other Asian") ? true : false
                        }
                        value={"Other Asian"}
                        onChange={this.onChangeRace}
                      >
                        Other Asian
                      </Checkbox>
                    </li>
                  </div>
                )}
                <li className="pb-1">
                  <Checkbox
                    value={"Black or African American"}
                    checked={
                      this.state.race.includes("Black or African American")
                        ? true
                        : false
                    }
                    onChange={this.onChangeRace}
                  >
                    Black or African American
                  </Checkbox>
                </li>
                <li className="pb-1">
                  <Checkbox
                    value={"Native Hawaiian or Other Pacific Islander"}
                    onChange={this.onChangeRace}
                    checked={
                      this.state.race.includes(
                        "Native Hawaiian or Other Pacific Islander"
                      )
                        ? true
                        : false
                    }
                  >
                    Native Hawaiian or Other Pacific Islander
                  </Checkbox>
                </li>
                <li className="pb-1">
                  <Checkbox
                    checked={this.state.race.includes("White") ? true : false}
                    value={"White"}
                    onChange={this.onChangeRace}
                  >
                    White
                  </Checkbox>
                </li>
                <li className="pb-1">
                  <Checkbox
                    checked={this.state.race.includes("Other") ? true : false}
                    value={"Other"}
                    onChange={this.onChangeRace}
                  >
                    Other
                  </Checkbox>
                </li>
                <li className="pb-1">
                  <Checkbox
                    checked={
                      this.state.race.includes("Prefer not to answer")
                        ? true
                        : false
                    }
                    value={"Prefer not to answer"}
                    onChange={this.onChangeRace}
                  >
                    Prefer not to answer
                  </Checkbox>
                </li>
              </ul>
              {this.state.race.includes("Other") && (
                <div>
                  <label className="col-lg-5 pl-0 mt-2 mb-3 tt-capitalize">
                    Specification
                  </label>
                  <br />
                  <TextArea
                    style={{
                      padding: 16,
                      fontSize: 18,
                    }}
                    rows={4}
                    placeholder="Specification..."
                    name="race_other_specification"
                    value={this.state.race_other_specification}
                    onChange={(e) => {
                      this.setState({
                        race_other_specification: e.target.value,
                      });
                    }}
                  />
                </div>
              )}
            </div>
            {this.state.ethnic_category.includes("Other") && (
              <div className="form-group">
                <label className="input-heading">
                  Specification <span className="text-danger">*</span>
                </label>
                <br />
                <TextArea
                  name="ethnicity_other_specification"
                  value={this.state.ethnicity_other_specification}
                  onChange={(e) => {
                    this.setState({
                      ethnicity_other_specification: e.target.value,
                    });
                  }}
                  rows="4"
                  cols="50"
                  maxlength="200"
                ></TextArea>
              </div>
            )}
            {this.props.is_update == true ? (
              <div className="d-flex mt-5">
                <button
                  className="submit-button"
                  style={{
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save()}
                >
                  Save{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            ) : (
              <div className="d-flex mt-5">
                <button
                  style={{
                    padding: "9px 28px 10px 21px",
                  }}
                  className="submit-button"
                  onClick={() => this.props.set_active_step(1)}
                >
                  <box-icon
                    name="chevron-left"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                  Previous
                </button>
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 17,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save()}
                >
                  Save & Next{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            )}
          </div>
        </Spin>
      </div>
    );
  }
}
